import React from 'react';
import { Outlet } from 'react-router-dom';

import '../../Mobile.css';
function Nutritionist() {

  return (
    <>
      <Outlet />
    </>
  );
}

export default Nutritionist;